import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '../components/SimpleQuizPage.vue';
import axios from "axios";

axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.xsrfCookieName = 'csrftoken';

const pinia = createPinia();

createApp(App)
  .use(pinia)
  .mount('#quiz');
